import Sidebar from '../../../components/sidebar/Sidebar';

import NotFoundPage from '../../../pages/page404/page404';

import SectionContent from '../../../components/sectionContent/sectionContent';

import '../../../scss/App.scss';

const Page404Section = () => {

	return (
		<div className='App'>
			<Sidebar />
			<SectionContent
				section='Страница 404'
			>
				<div className='content__main'>
          <NotFoundPage/>
				</div>
			</SectionContent>
		</div>
	);
};

export default Page404Section;
